<template>
    <section id="notice">
        <div class="container">
            <h2 class="title mt-50 mb-40">活動辦法</h2>
            <article class="content">
                <p>【活動辦法】</p>
                <ol class="list-lv1">
                    <li>主辦單位：新安東京海上產物保險股份有限公司</li>
                    <li>活動名稱：網路投保—好禮三重抽</li>
                    <li>活動期間：2026年07月01日00：00 至2026年12月31日23：59止 </li>
                    <li>活動說明：於活動期間內，以保單要保人資料成為新安東京海上產險網路投保會員，完成以下任務，即可獲得該任務抽獎機會。 
                        <ol class="list-lv2">
                            <li>【車體險加碼獎-雙週抽iPhone Duo】：<br>
                                於2026/10/01至2026/12/31，新安東京海上產險網路投保專區成功投保指定汽車車體險，並完成指定條件，
                                即可取得抽獎資格乙次，並依本活動辦法參與各週抽獎。
                                <ol class="list-lv3">
                                    <li>指定車體險：投保汽車甲式、乙式、丙式車體險(含新保、續保)，須核保成功並完成繳費 </li>
                                    <li>指定條件：
                                        <ul class="list-lv4">
                                            <li>登入會員</li>
                                            <li>選擇電子保單 (若投保完成後才更改為電子保單，將不具抽獎資格) </li>
                                            <li>投保前加入並綁定新安東京海上產險LINE官方帳號<br>
                                                * 首次綁定LINE官方帳號可額外獲得10點LINE POINTS點數！</li>
                                        </ul>
                                    </li>
                                    <li>以純電動汽車投保符合本活動資格之汽車車體險者，每張保單可額外獲得抽獎機會乙次。 </li>
                                    <li>週次計算(以完成核保及繳費成功時間認定所屬週次，各週依下述期間計算。)： 
                                         <ul class="list-lv4">
                                            <li>第一週：10/1-10/14</li>
                                            <li>第二週：10/15-10/31</li>
                                            <li>第三週：11/1-11/14</li>
                                            <li>第四週：11/15-11/30 </li>
                                            <li>第五週：12/1-12/15 </li>
                                            <li>第六週：12/16-12/31 </li>
                                        </ul>
                                    </li>
                                    <li>季末加碼：凡於活動期間完成投保，且未於上述各週抽中獎項者，仍可參加季末加碼抽獎。季末加碼抽獎機會計算方式與各週抽獎相同，一般符合資格保單為1次抽獎機會；純電動汽車符合資格保單為2次抽獎機會，並於活動結束後統一彙整並抽出 iPhone Duo 乙支。</li>
                                </ol>
                            </li>
                            <li>【立即抽】：於新安東京海上產險網路投保專區成功投保以下指定保險商品，即可獲得【立即抽】抽獎機會乙次，投保單數越多，可獲得之抽獎機會亦越多。
                                <ol class="list-lv3">
                                    <li>汽、機車險：強制險＋任意險(需同時投保在一張保單內)</li>
                                    <li>汽、機車險：任意險＋電子保單(投保完成後始更改為電子保單者，將不納入抽獎資格)<br>(投保汽、機車險單筆保單同時完成上述第1項或第2項任務者，僅可獲得【立即抽】抽獎機會乙次)</li>
                                    <li>住宅火險(任一方案)＋電子保單</li>
                                    <li>旅行平安險(任一方案)</li>
                                    <li>傷害險(任一方案)</li>
                                </ol>
                            </li>
                        </ol>
                    </li>
                </ol>
                <transition
                    name="slide"
                    @before-enter="beforeEnter"
                    @enter="enter"
                    @after-enter="afterEnter"
                    @before-leave="beforeLeave"
                    @leave="leave"
                    @after-leave="afterLeave"
                >
                    <div class="slideCon" v-if="active == true">
                        <ol class="list-lv1" start="5">
                            <li value="4" style="display:none"></li><!-- placeholder to continue numbering -->
                        </ol>
                        <!-- 四(三)以下延續 indent2 list -->
                        <ol class="list-lv2 slide-list">
                            <li>【立即抽-車險加碼獎】：於新安東京海上產險網路投保專區成功投保汽、機車險商品，符合以下條件，可額外獲得【立即抽】抽獎次數：
                                <ol class="list-lv3">
                                    <li>車險續保獎：<br>
                                        續保戶透過續保入口於線上完成汽、機車投保強制險+任意險續保，即可獲得【立即抽】抽獎機會兩次。</li>
                                    <li>車險喬遷獎：<br>
                                        於線上投保專區完成汽、機車強制險投保，且前一期保單非投保新安東京海上產險者，即可獲得【立即抽】抽獎機會乙次。投保當下若無有效之強制險保單者，即不符合喬遷獎活動資格。另，新車投保、二手車過戶或強制險斷保之情形，亦不適用本獎項。<br>
                                        投保當下無有效的強制險保單即不符合喬遷獎活動資格，如為新車投保、二手車過戶、強制險斷保皆不符合喬遷獎抽獎資格。<br>
                                        *斷保：強制險保期不接續、前後保單中間有空窗時間，例如：強制險2026/01/01到期，2026/01/05投保完成，2026/01/05保單才開始生效，即為斷保。</li>
                                    <li>車險新保獎：<br>
                                        於線上投保專區完成汽、機車險投保，且該車號及要保人過去未曾於新安東京海上產險網路投保專區投保汽車險或機車險(不論強制險或任意險)，即可獲得【立即抽】抽獎機會乙次。<br>
                                        您可於活動頁面查詢各獎項抽獎次數，所有抽獎皆須於活動期間內完成，且至少完成一次活動頁面登入，始符合活動資格。若未能於活動時間內完成登入、主動進行【立即抽】，視同放棄參與活動資格。</li>
                                </ol>
                            </li>
                            <li>【大獎】：於新安東京海上產險網路投保專區成功投保，符合【立即抽】指定保險商品資格者，可同步獲得【大獎】抽獎資格乙次。</li>
                            <li>【電子保單獎】：於新安東京海上產險網路投保專區成功投保，符合【大獎】資格並選擇使用電子保單者，即可獲得【電子保單獎】抽獎機會乙次。</li>
                            <li>同時符合上述(二)、(四)、(五)資格者，每張保單可分別獲得【立即抽】、【大獎】及【電子保單獎】三項抽獎機會。兩張保單即可獲得三筆抽獎機會各兩次，依此類推…。<br>
                                <p class="note">(舉例：小安在活動期間網路投保強制汽車責任險+任意險，且選擇電子保單，同時也投保了住火險並且選擇電子保單。兩筆保單，總共可以獲得兩次【立即抽】、兩次【大獎】抽獎機會，因為兩筆保單都有選電子保單，還可獲得兩次的【電子保單獎】抽獎機會。)</p>
                            </li>
                            <li>【機車強制險加碼獎】：於2026/10/01至2026/12/31，新安東京海上產險網路投保專區成功投保以下條件，即可獲得【機車強制險加碼獎】抽獎機會一次： 
                                <ol class="list-lv3">
                                    <li>投保機車強制責任保險二年期保單</li>
                                    <li>勾選電子保單</li>
                                </ol>
                            </li>
                        </ol>

                        <ol class="list-lv1" start="5">
                            <li>抽獎說明：
                                <ol class="list-lv2">
                                    <li>【車體險加碼獎-雙週抽iPhone Duo】：
                                        <ol class="list-lv3">
                                            <li>如於活動期間內投保多張保單，則每張皆具一次抽獎機會，惟各需符合活動條件。</li>
                                            <li>抽獎資格採累計制，每張符合資格之保單，自符合資格當週起至活動結束前，皆可參與後續各週抽獎；若該保單於任一週中獎，則不再列入後續週次抽獎名單。例如：A保單於活動第2週符合得獎資格，該保單即具備第2週至活動最後一週抽獎機會；若該保單於第 2 週中獎，則往後週數獎池不再計入該保單。 </li>
                                            <li>活動期間每週抽出一名得獎人，對應週次名單，中獎名單將於隔週公告於新安東京海上產險網路投保專區的得獎公告頁公布。  </li>
                                            <li>季末加碼獎：凡於活動期間完成投保，且未於上述各週抽中獎項者，仍可參加季末加碼抽獎。主辦單位將依投保車種計算對應抽獎機會，於活動結束後統一彙整並抽出 iPhone Duo 乙支。 </li>
                                            <li>為確保活動正確統計，參加者投保前且於活動期間持續維持新安東京海上產險LINE官方帳號綁定狀態，若因封鎖或解除綁定導致統計異常，視同自動放棄中獎資格，恕不補發，亦不另行通知。 </li>
                                        </ol>
                                    </li>
                                    <li>【立即抽】：參加者於網路完成投保後，需經過投保審核流程。經確認投保及付款成功後，抽獎機會將於約 2 個工作天內匯入。完成活動頁面登入後，即可進行【立即抽】，並即時得知是否中獎。<br>
                                        (提醒您：LINE POINTS序號、電子禮券為虛擬、不記名有價票券，請您妥善保管)</li>
                                    <li>【大獎】：於保單投保核審成功後，即可獲得【大獎】抽獎機會乙次，並依要保時間於對應活動期間內，以電腦亂序方式抽出得獎者。</li>
                                    <li>【電子保單獎】：投保任一保單，符合【大獎】資格並勾選電子保單，即可獲得【電子保單獎】抽獎機會，並依要保時間於對應活動期間內，以電腦亂序方式抽出得獎者。</li>
                                    <li>【機車強制險加碼獎】：投保指定險種及活動條件，即可獲得【機車強制險加碼獎】抽獎機會，並依要保時間於對應活動期間內，以電腦亂序方式抽出得獎者。 </li>
                                    <li>若於抽獎日前有撤銷投保、退保、契約解除、拒保、變更被保險人、變更要保人資料或其他不符合活動資格情形者，視為放棄抽獎及中獎資格。</li>
                                    <li>您可於活動頁面查詢【立即抽】、【大獎】、【電子保單獎】抽獎次數，抽獎機會使用期限僅限活動公告時間內，所有抽獎皆須於活動時間內，至少完成一次活動頁面登入，始可符合資格。若未能於活動時間內完成登入、主動進行【立即抽】抽獎，或因投保時間而造成抽獎機會無法即時匯入，而造成無法於活動時間內參與活動，將視為放棄活動一切權利。</li>
                                    <li>主辦單位將於活動截止後進行抽獎，除正取名額外，將同時抽出相同數量的備取名單。若正取得獎者於通知期限內未回覆、資格不符或放棄得獎資格時，主辦單位將依序以備取名單遞補。備取遞補後若仍有名額不足，主辦單位有權決定是否再行抽獎或取消該獎項。</li>
                                </ol>
                            </li>
                            <li>查詢個人抽獎機會數量：<br>
                                參加者可用會員註冊時的【身分證字號】登入活動，至抽獎機會使用紀錄中查詢個人抽獎機會明細。若對抽獎次數有疑問，可撥打0800-366168或E-mail至網路投保活動小組詢問。<a href='mailto:rex.chen@tmnewa.com.tw'>&lt; E-mail : rex.chen@tmnewa.com.tw ></a>
                            </li>
                            <li>獎項內容：
                                <ol class="list-lv2">
                                    <li>【車體險加碼獎】
                                        <ul class="list-lv4">
                                            <li>iPhone Duo 256G（顏色隨機） 共7支</li>
                                        </ul>
                                    </li>
                                    <li>【立即抽】
                                        <ul class="list-lv4">
                                            <li>即享券300元(電子禮券)&nbsp;&nbsp;&nbsp;共150名</li>
                                            <li>即享券100元(電子禮券)&nbsp;&nbsp;&nbsp;共300名</li>
                                            <li>即享券25元(電子禮券)&nbsp;&nbsp;共1,200名</li>
                                            <li>LINE POINTS 8點&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;共2,400名</li>
                                        </ul>
                                    </li>
                                    <li>【大獎】
                                        <ul class="list-lv4">
                                            <li>歌詩達郵輪-莎倫娜號沖繩自主行4天-海景房雙人房(7-9月獎項，將10月進行抽獎)&nbsp;&nbsp;共1名</li>
                                            <li>iPhone 18 Pro 256G顏色隨機 (10-12月獎項，將於2027年1月進行抽獎)
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;共1名</li>
                                        </ul>
                                    </li>
                                    <li>【電子保單獎】
                                        <ul class="list-lv4">
                                            <li>A獎 日本千石阿拉丁 遠紅外石墨大烤盤 AMG-G1300T (7-9月獎項，將於10月進行抽獎)&nbsp;&nbsp;&nbsp;共1名</li>
                                            <li>B獎 Nintendo Switch 2 賽車世界 主機組合 (7-9月獎項，將於10月進行抽獎)&nbsp;&nbsp;&nbsp;共1名</li>
                                            <li>C獎 日本千石阿拉丁 遠紅外石墨大烤盤 AMG-G1300T (10-12月獎項，將於2027年1月進行抽獎)&nbsp;&nbsp;&nbsp;共1名</li>
                                            <li>D獎 日本IRIS OHYAMA 乾燥循環除濕機 (10-12月獎項，將於2027年1月進行抽獎)&nbsp;&nbsp;&nbsp;共1名</li>
                                        </ul>
                                    </li>
                                    <li>【機車強制險加碼獎】 
                                         <ul class="list-lv4">
                                            <li>即享券200元(電子禮券)       共50名 </li>
                                         </ul>
                                    </li>
                                </ol>
                            </li>
                            <li>注意事項
                                <ol class="list-lv2">
                                    <li>【車體險加碼獎-iPhone Duo】說明： <br>
                                       若因產品上市時程、供貨狀況、價格變動、缺貨或其他不可歸責於主辦單位之因素，主辦單位保留調整獎項型號、規格、顏色或提供同等價值獎項之權利，中獎者不得指定或要求折換現金，亦不得異議。 
                                    </li>
                                    <li>
                                        【好禮三重抽大獎-歌詩達郵輪 莎倫娜號沖繩自主行4天海景房雙人房】說明：<br>
                                        本獎項實際內容為「東南旅行社禮券新臺幣 10,000 元 × 4 張」乙份，由東南旅行社提供，每張憑證可抵換價值新臺幣 10,000 元之旅遊行程，合計共 4 張。得獎者收到本憑證後，若無意兌換郵輪行程，亦可改兌換等值之東南旅行社所販售旅遊商品（詳細兌換資訊及使用期限以兌獎憑證所載內容為準），確認欲訂購（報名）之商品後，請以電話方式聯繫東南旅行社承辦窗口人員，並以人工下單方式進行後續折抵作業。憑證如逾期未完成兌換，視為放棄權益；本憑證限一次全額使用，不得分次使用、折現或找零。若實際票價超過憑證金額，差額須由得獎者自行負擔；未達憑證金額部分恕不退還。其他未盡事項，悉依東南旅行社相關規定辦理，因此所生之消費或履約爭議，概與新安東京海上產險無涉。
                                    </li>
                                    <li>
                                        【好禮三重抽大獎-iPhone 18 Pro 256G(顏色隨機)】說明：<br>
若因贈品缺貨或其他不可歸責於主辦單位之因素，致無法提供原定獎項，主辦單位將改以百貨電子禮券新臺幣 40,000 元作為替代發放，中獎者不得異議。
                                    </li>
                                    <li>
                                        本活動各項抽獎資格均以「保單數」為計算基準。同一張保單如包含多位被保險人，視為一張保單計算，抽獎機會不因被保險人人數或保費金額增加而增加。
                                    </li>
                                    <li>
                                        您參與本活動時，視為同意接受本活動所有內容及相關規範；倘有違反本活動相關注意規範，主辦單位得取消其參加或獲獎資格，並對於任何破壞本活動之行為保留法律追訴權。
                                    </li>
                                    <li>
                                        本活動因故無法進行時，主辦單位保留對活動網站、活動規則、獎項、抽獎時間及中獎公告等的修改權利，修改後不另行通知。
                                    </li>
                                    <li>
                                        各項抽獎資格之取得均以保單符合活動條件且完成核保及繳費成功為前提。若因撤銷投保、退保、契約解除、拒保、資料不符或其他不符合活動資格情形者，主辦單位有權取消抽獎資格及中獎資格。 
                                    </li>
                                    <li>
                                        參加者同意活動期間內所有留存或產生之任何參與活動的資料及紀錄，皆以主辦單位的電腦系統與時間的紀錄為主。如有任何因電腦、網路、電話、技術或不可歸責於主辦單位之事由，而使送出之資料有延遲、遺失、錯誤、無法辨識之情況，主辦單位不負責任何法律責任，參加者不得因此異議。
                                    </li>
                                    <li>
                                        參加者保證所填寫或提出之資料真實無誤，且未冒用或盜用第三人之資料，如主辦單位依參加者提供之資料無法通知其中獎時，主辦單位概不負責，如因此致損害於主辦單位或其他任何第三人，參加者應負責一切相關責任。
                                    </li>
                                </ol>
                            </li>
                            <li>中獎流程
                                <ol class="list-lv2">
                                    <li>【車體險加碼獎】每週中獎名單由主辦單位以電腦隨機抽選，並於隔週於新安東京海上產險網路投保專區的<router-link class="link" target="_blank" to="/lotterypage/detail_winner_list">得獎公告頁</router-link>公布。得獎人完成領獎程序後寄送，實際贈品寄送時間以主辦單位通知為主。 </li>
                                    <li>【大獎】、【電子保單獎】將於2026年10月17日前、2027年1月17日前，依電腦亂序抽出對應獎項，並公布得獎名單於新安東京海上產險網路投保專區<router-link class="link" target="_blank" to="/lotterypage/detail_winner_list">得獎公告頁</router-link>。得獎人完成領獎程序後寄送。</li>
                                    <li>【機車強制險加碼獎】將於2027年1月17日前，依電腦亂序抽出對應獎項，並公布得獎名單於新安東京海上產險網路投保專區<router-link class="link" target="_blank" to="/lotterypage/detail_winner_list">得獎公告頁</router-link>。</li>
                                    <li>領獎程序說明：中獎者於接獲中獎通知E-mail後，請於7日內填寫領獎簽收單，拍照或掃描後以E-mail方式回覆中獎通知，以利後續寄送作業，獎項將於主辦單位確實收齊領獎相關資料後才會進行寄送。中獎者需於公告期限內回覆領獎相關資料，逾期將視同自動放棄領獎資格，主辦單位將不會另行通知。</li>
                                    <li>獎項將透過郵寄、手機簡訊、電子郵件等方式寄送，請務必確認填寫資料的正確性。不論實體獎品或虛擬兌換序號，一經發送若遭拒絕受領(不論實際拒絕受領者為何人)、無人收受、地址錯誤、手機號碼錯誤或查無此人者，主辦單位概不負責補發，並有權視中獎者為棄權，而有權拒絕核發其所中之獎項(若有預繳之稅金將進行退回)，中獎者不得異議，獎品寄出後若有遺失、冒領、被竊等喪失占有之情形，一概與主辦單位無關，亦不得要求補發或其他等價之補償。</li>
                                </ol>
                            </li>
                            <li>主辦單位非獎品製造者或提供者，與各項獎品製造或服務提供之廠商無任何代理或合夥關係，本活動獎品之保固期限均依廠商出廠時實際提供者為準。本抽獎活動、獎品、禮券僅作為推展保險產品行銷之用途，並非保險契約之一部分。本活動之所有獎項不得要求更換、轉換或折換現金。如領取後對獎品之使用方式、售後服務、保固等發生任何爭議，概與主辦單位無關。如遇產品缺貨或不可抗力之事由導致獎品內容變更，主辦單位有權變更贈品，改由等值商品取代之，得獎者不得異議。</li>
                            <li>獎項寄送地區僅限為台灣、金門、澎湖、馬祖地區，主辦單位恕不處理郵寄獎項至海外地區之事宜，獎項一經寄送，本主辦單位不負獎品無法送達及寄送時發生損毀之責任；若遇產品故障需自行與產品製造商等連繫後續保修事宜。</li>
                            <li>本活動屬機會中獎所得，依「所得稅法」及「各類所得扣繳率標準」之規定，說明如下：若獲獎者或中獎者為中華民國境內居住之個人，於全年度中獎之獎項金額超過新台幣$1,000元，獲獎者或中獎者於年度報稅時須計入個人所得，中獎金額達新台幣 20,011 元（含）以上，須先預先繳交10%機會中獎稅額；若獲獎者或中獎者非中華民國境內居住之個人(即在中華民國境內居住未達183天)，不論獲獎者或中獎者所得之金額，須就中獎金額扣繳20%機會中獎稅額，若未繳交稅金視同放棄中獎資格。</li>
                            <li>【個人資料告知事項】<br>
                                本公司依據個人資料保護法（以下稱個資法）第六條第二項、第八條第一項(如為間接蒐集之個人資料則為第九條第一項)規定，應告知下列事項，敬請 台端詳閱及知悉：
                                <ol class="list-lv2">
                                    <li>蒐集目的
                                        <ol class="list-lv3">
                                            <li>中獎者管理</li>
                                            <li>活動相關信息通知</li>
                                            <li>贈品寄送</li>
                                        </ol>
                                    </li>
                                    <li>蒐集之個人資料類別：<br>
                                        包括但不限於姓名、身分證字號、出生年月日、住址、聯絡方式、婚姻、家庭、教育職業、財務情況、病歷、醫療、健康檢查、其他得以直接或間接方式識別該個人之資料，詳如活動頁內容。</li>
                                    <li>利用之期間、地區、對象及方式
                                        <ol class="list-lv3">
                                            <li>期間：<br>
                                                因執行業務所必須及依法令規定應為保存之期間。</li>
                                            <li>對象：<br>
                                                本(分)公司、贈品寄送之物流公司或郵寄廠商。</li>
                                            <li>地區：<br>
                                                上述對象所在之地區。</li>
                                            <li>方式：<br>
                                                合於法令規定之利用方式。</li>
                                        </ol>
                                    </li>
                                    <li>依據個資法第三條規定，台端就本公司保有台端之個人資料得行使之權利及方式：
                                        <ol class="list-lv3">
                                            <li>得向本公司行使之權利：
                                                <ol class="list-lv3 list-paren-num">
                                                    <li>向本公司查詢、請求閱覽或請求製給複製本。</li>
                                                    <li>向本公司請求補充或更正。</li>
                                                    <li>向本公司請求停止蒐集、處理或利用及請求刪除。</li>
                                                </ol>
                                            </li>
                                            <li>行使權利之方式：<br>
                                                以書面或其他日後可供證明之方式。台端不提供個人資料所致權益之影響（個人資料由當事人直接蒐集之情形適用）：台端若未能提供相關個人資料時，本公司將可能無法提供台端參加本活動及其後續相關服務。</li>
                                        </ol>
                                    </li>
                                </ol>
                            </li>
                        </ol>
                    </div>
                </transition>
            </article>
            <div class="togglebutton" @click="toggle">{{ buttonTxt }}<svg class="arrow" xmlns="http://www.w3.org/2000/svg" width="18" height="11" viewBox="0 0 18 11" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.00556 1.48533C1.55086 0.861677 2.49848 0.798157 3.12213 1.34345L8.99696 6.48016L14.8718 1.34345C15.4954 0.798157 16.4431 0.861677 16.9884 1.48533C17.5337 2.10898 17.4701 3.0566 16.8465 3.6019L8.99696 10.4652L1.14744 3.6019C0.523787 3.0566 0.460266 2.10898 1.00556 1.48533Z" fill="white"/>
            </svg></div>
        </div>
    </section>
</template>

<script setup>
import { ref } from 'vue';

const active = ref(false);
const buttonTxt = ref("展開內容");
const toggle = () => {
    active.value = !active.value;
    buttonTxt.value = active.value ? "收合內容" : "展開內容";
    document.querySelector('.togglebutton').classList.toggle('open', active.value);
};
const beforeEnter = (element) => {
    requestAnimationFrame(() => {
        element.style.height = "0px";
        element.style.display = null;
    });
};
const enter = (element) => {
    requestAnimationFrame(() => {
        element.style.height = `${element.scrollHeight}px`;
    });
};

const afterEnter = (element) => {
    element.style.height = null;
};

const beforeLeave = (element) => {
    requestAnimationFrame(() => {
        element.style.height = `${element.scrollHeight}px`;
    });
};
const leave = (element) => {
    requestAnimationFrame(() => {
        element.style.height = "0px";
    });
};

const afterLeave = (element) => {
    element.style.height = null;
};

</script>
<style lang="scss">
#notice {
    .content {
        background: $white;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        line-height: 28px;
        box-sizing: border-box;
        padding: 30px;
        overflow: hidden;
        border: 2px solid $black;
        text-align: justify;
        font-size: 16px;
        @media screen and (max-width: $mobile-small) {
            font-size: 16px;
            line-height: 24px;
        }

        // 一、二、三、（中文數字序號）
        ol.list-lv1 {
            list-style-type: cjk-ideographic;
            padding-left: 2em;
            margin: 0;
        }

        // (一)(二)(三)（圓括號中文數字）
        ol.list-lv2 {
            list-style-type: cjk-ideographic;
            padding-left: 2em;
            margin: 4px 0;
            > li::marker {
                content: "(" counter(list-item, cjk-ideographic) ") ";
            }
        }

        // 1. 2. 3.
        ol.list-lv3 {
            list-style-type: decimal;
            padding-left: 2em;
            margin: 4px 0;
        }

        // ‧ disc bullet
        ul.list-lv4 {
            list-style-type: disc;
            padding-left: 2em;
            margin: 4px 0;
        }

        ol, ul {
            li {
                margin-bottom: 4px;
            }
        }

        // (1)(2)(3)
        ol.list-paren-num {
            list-style-type: decimal;

            > li::marker {
                content: "(" counter(list-item) ") ";
            }
        }

        .note {
            margin: 4px 0;
            font-size: 15px;
        }

        .slide-list {
            counter-reset: list-item 2; // start from (三)
        }
    }

    .togglebutton {
        margin-top: -8px;
        padding: 1em;
        background-color: $blue-700;
        color: $white;
        cursor: pointer;
        border-bottom-left-radius: 20px;
        border-bottom-right-radius: 20px;
        text-align: center;
        border: 2px solid $black;
        border-top:0;
        font-weight:700;

        &:hover {
            background: #0167c3;
            transition: all 200ms linear;
        }
        .arrow{margin-left:10px;transition: all 200ms linear;}
        &.open{
            .arrow{
                transform: rotate(180deg);
                transition: all 200ms linear;
            }
        }
    }
}

.slide-leave-active,
.slide-enter-active {
    overflow: hidden;
    transition: height 0.5s linear;
}
</style>
